import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DesenharPropriedadePage } from './desenhar-propriedade.page';

const routes: Routes = [
  {
    path: '',
    component: DesenharPropriedadePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DesenharPropriedadePageRoutingModule {}
